import React from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  IconButton,
  Paper,
  Divider,
  TableContainer,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { ArrowUp, Download } from "lucide-react";
import { fontSize } from "@mui/system";

const headerTextSx = {
  fontWeight: 500,
  color: "rgba(18, 18, 18, 1)",
  fontSize: 14,
};

const invoiceFieldSx = {
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "110%",
  letterSpacing: 0,
  color: "rgba(33, 39, 42, 1)",
};
const BillingCellSx = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "110%",
  letterSpacing: "0%",
  color: "rgba(101, 101, 101, 1)",
};

const PlanProSx = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "100%", // or "1" if you're not using a percentage
  letterSpacing: "0%",
  verticalAlign: "middle",
  color: "rgba(31, 31, 31, 1)", // or use theme var if defined
};
const PlanPriceSx = {
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "100%", // Or use "1" if MUI complains
  letterSpacing: "0%",
  verticalAlign: "middle",
  color: "rgba(107, 142, 118, 1)",
  borderRadius: "8px", // Optional: for rounded corners
  display: "inline-block", // Optional: for layout consistency
};

const invoiceData = [
  {
    id: "#1023",
    date: "May 15, 2022",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1016",
    date: "Nov 28, 2020",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1022",
    date: "Nov 13, 2018",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1018",
    date: "Mar 9, 2013",
    status: "Cancelled",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1022",
    date: "Nov 13, 2018",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1030",
    date: "Nov 13, 2018",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1028",
    date: "Nov 13, 2018",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1021",
    date: "Nov 2, 2011",
    status: "Failed",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1012",
    date: "Nov 13, 2018",
    status: "Paid",
    amount: "₹2,999",
    plan: "Pro",
  },
  {
    id: "#1003",
    date: "Nov 2, 2011",
    status: "Failed",
    amount: "₹2,999",
    plan: "Pro",
  },
];

const getStatusChip = (status) => {
  let bgColor = "";
  let textColor = "";
  let dotColor = "";

  switch (status) {
    case "Paid":
      bgColor = "rgba(165, 255, 150, 0.28)";
      textColor = "rgba(30, 150, 9, 1)";
      dotColor = "rgba(30, 150, 9, 1)";
      break;
    case "Cancelled":
    case "Failed":
      bgColor = "rgba(167, 9, 9, 0.05)";
      textColor = "rgba(167, 9, 9, 1)";
      dotColor = "rgba(167, 9, 9, 1)";
      break;
    default:
      bgColor = "#e0e0e0";
      textColor = "#000";
      dotColor = "#999";
      break;
  }

  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 500,
        fontSize: "0.75rem",
        ".MuiChip-icon": {
          marginLeft: "4px", // Adjust spacing between dot and label
        },
      }}
      icon={
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: dotColor,
          }}
        />
      }
    />
  );
};

const TransactionHistory = () => {
  return (
    <Box
      p={3}
      sx={{
        width: "100%",
        // borderRadius: 2,
        // border: "1px solid rgba(221, 221, 221, 1)",
        boxShadow: 0,
        // backgroundColor: "#fff",
      }}
    >
      {" "}
      <Box elevation={2} sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Transaction History
        </Typography>

        <Box
          sx={{
            border: "1px solid var(--Stroke, rgba(237, 237, 237, 1))",
            p: 3,
            borderRadius: 2,
          }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          my={2}
        >
          <Box>
            <Typography sx={PlanProSx}>Plan: Pro</Typography>
            <Typography className="mt-1" sx={BillingCellSx}>
              per user/month, billed annually
            </Typography>
            <Typography className="mt-2" sx={PlanPriceSx}>
              ₹2,999
            </Typography>
          </Box>
          <Button
            variant="outlined"
            sx={{
              border: "1px solid rgba(107, 142, 118, 1)",
              color: "rgba(107, 142, 118, 1)",
            }}
          >
            Upgrade Plan
          </Button>
        </Box>

        <Divider sx={{ my: 2 }} />

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            boxShadow: 0,
            border: "1px solid rgba(221, 221, 221, 1)",
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "rgba(240, 240, 240, 1)" }}>
                {" "}
                {/* light gray */}
                <TableCell>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography sx={headerTextSx}>Invoice</Typography>
                    <ArrowUp
                      sx={{ color: "rgba(101, 101, 101, 1)" }}
                      size={16}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography sx={headerTextSx}>Billing Date</Typography>
                    <ArrowUp
                      sx={{ color: "rgba(101, 101, 101, 1)" }}
                      size={16}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography sx={headerTextSx}>Status</Typography>
                    <ArrowUp
                      sx={{ color: "rgba(101, 101, 101, 1)" }}
                      size={16}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography sx={headerTextSx}>Amount</Typography>
                    <ArrowUp
                      sx={{ color: "rgba(101, 101, 101, 1)" }}
                      size={16}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography sx={headerTextSx}>Plan</Typography>
                    <ArrowUp
                      sx={{ color: "rgba(101, 101, 101, 1)" }}
                      size={16}
                    />
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Typography sx={headerTextSx}>Action</Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {invoiceData.map((invoice, index) => (
                <TableRow key={index}>
                  <TableCell sx={invoiceFieldSx}>
                    Invoice {invoice.id}
                  </TableCell>
                  <TableCell sx={BillingCellSx}>{invoice.date}</TableCell>
                  <TableCell>{getStatusChip(invoice.status)}</TableCell>
                  <TableCell sx={BillingCellSx}>{invoice.amount}</TableCell>
                  <TableCell sx={BillingCellSx}>{invoice.plan}</TableCell>
                  <TableCell align="center">
                    <IconButton>
                      <Download
                        color="rgba(107, 142, 118, 1)"
                        fontSize="small"
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default TransactionHistory;
